/** es-MX formatting. Dates from the API are DATE columns serialised as ISO strings; the civil date is the first 10 chars. */
const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const MONTHS_LONG = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

export function civil(d: string | null | undefined): { y: number; m: number; d: number } | null {
  if (!d) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d);
  if (m) return { y: +m[1]!, m: +m[2]!, d: +m[3]! };
  const t = new Date(d); if (Number.isNaN(t.getTime())) return null;
  return { y: t.getFullYear(), m: t.getMonth() + 1, d: t.getDate() };
}
export const isoDate = (d: string | null | undefined): string => { const c = civil(d); return c ? `${c.y}-${String(c.m).padStart(2, '0')}-${String(c.d).padStart(2, '0')}` : ''; };
/** `26 ago`, or `26 ago 2027` when the date is not in the current year (fiscal deadlines and old queue items would read ambiguous otherwise). */
export const dateShort = (d: string | null | undefined): string => { const c = civil(d); return c ? `${c.d} ${MONTHS[c.m - 1]}${c.y !== new Date().getFullYear() ? ` ${c.y}` : ''}` : ''; };
export const dateSlash = (d: string | null | undefined): string => { const c = civil(d); return c ? `${String(c.d).padStart(2, '0')}/${String(c.m).padStart(2, '0')}/${c.y}` : ''; };
export function dateRange(from: string | null | undefined, to: string | null | undefined, long = false): string {
  const a = civil(from), b = civil(to ?? from);
  if (!a) return '';
  const mon = (m: number) => (long ? `de ${MONTHS_LONG[m - 1]}` : MONTHS[m - 1]);
  if (!b || (a.y === b.y && a.m === b.m && a.d === b.d)) return `${a.d} ${mon(a.m)}`;
  if (a.y === b.y && a.m === b.m) return `${a.d}–${b.d} ${mon(a.m)}`;
  return `${a.d} ${mon(a.m)} – ${b.d} ${mon(b.m)}`;
}
export function dateTime(iso: string): string {
  const t = new Date(iso); if (Number.isNaN(t.getTime())) return '';
  return `${t.getDate()} ${MONTHS[t.getMonth()]} · ${String(t.getHours()).padStart(2, '0')}:${String(t.getMinutes()).padStart(2, '0')}`;
}
export function money(n: number | null | undefined, opts: { cents?: boolean; currency?: string | null } = {}): string {
  if (n == null || Number.isNaN(n)) return '—';
  const s = new Intl.NumberFormat('es-MX', { minimumFractionDigits: opts.cents ? 2 : 0, maximumFractionDigits: opts.cents ? 2 : 0 }).format(n);
  const cur = opts.currency && opts.currency !== 'MXN' ? ` ${opts.currency}` : '';
  return `$${s}${cur}`;
}
export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** Instants (created_at, due_at, attempt times) in America/Mexico_City whatever the browser's zone — the console's clock, like every worker's. */
const MX = new Intl.DateTimeFormat('es-MX', { timeZone: 'America/Mexico_City', year: 'numeric', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false });
const yearMx = (t: Date) => Object.fromEntries(MX.formatToParts(t).map((x) => [x.type, x.value])).year;
export function dateTimeMx(iso: string | null | undefined): string {
  if (!iso) return ''; const t = new Date(iso); if (Number.isNaN(t.getTime())) return '';
  const p = Object.fromEntries(MX.formatToParts(t).map((x) => [x.type, x.value]));
  const year = p.year !== yearMx(new Date()) ? ` ${p.year}` : '';
  return `${p.day} ${(p.month ?? '').replace('.', '')}${year} · ${p.hour}:${p.minute}`;
}
